import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SparklesIcon, ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-gradient-to-b from-cream via-terracotta-50 to-cream py-20 px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto" data-id="element-178">
        <motion.div className="relative bg-warmWhite rounded-3xl p-8 sm:p-12 shadow-warm-lg border border-terracotta-200 overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-179">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-bl from-terracotta-100 to-transparent rounded-bl-full opacity-50" data-id="element-180" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-sage-100 to-transparent rounded-tr-full opacity-50" data-id="element-181" />

          {/* Decorative icons */}
          <div className="absolute top-8 right-8 text-terracotta-200" data-id="element-182">
            <MoonIcon className="w-10 h-10" data-id="element-183" />
          </div>
          <div className="absolute bottom-8 left-8 text-sage-200" data-id="element-184">
            <SparklesIcon className="w-8 h-8" data-id="element-185" />
          </div>

          <div className="relative text-center" data-id="element-186">
            <p className="font-body text-lg text-warmGray mb-6 max-w-xl mx-auto" data-id="element-187">
              Recupera tu cordura y el sueño de tu bebé por menos de lo que
              cuesta un paquete de pañales. Obtén el Manual de Supervivencia
              completo hoy mismo.
            </p>

            <div className="mb-8" data-id="element-188">
              <span className="inline-block bg-terracotta-100 text-terracotta font-semibold text-sm uppercase tracking-wider px-4 py-1 rounded-full mb-4" data-id="element-189">
                Oferta Especial — Solo por Hoy
              </span>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-190">
                <span className="font-heading text-3xl sm:text-4xl text-warmGray/50 line-through decoration-warmGray/40" data-id="element-191">
                  $70.000
                </span>
                <span className="font-heading text-6xl sm:text-7xl text-terracotta font-bold" data-id="element-192">
                  $35.000
                </span>
                <span className="font-body text-2xl text-warmGray" data-id="element-193">COP</span>
              </div>
              <p className="font-body text-sm text-sage font-semibold mt-2" data-id="element-194">
                Ahorras $35.000 COP — 50% de descuento
              </p>
            </div>

            <motion.a href="https://www.aky.com.co/cart/45243803140287:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracotta text-white font-semibold text-lg px-10 py-5 rounded-full shadow-warm-lg mb-4" whileHover={{
            scale: 1.03,
            boxShadow: '0 15px 50px -8px rgba(196, 149, 106, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-195">
              ¡QUIERO DORMIR POR FIN! – DESCARGAR AHORA
            </motion.a>

            <p className="font-body text-warmGray text-sm mb-8" data-id="element-196">
              Acceso inmediato tras el pago. Tu descanso empieza esta noche.
            </p>

            <div className="flex items-center justify-center gap-2 text-sage" data-id="element-197">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-198" />
              <span className="font-body text-sm" data-id="element-199">Pago seguro y protegido</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}